import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";
import { useI18n } from "utils/with-i18n.utils";

export const CatalogBannerComingSoon = () => {
  const i18n = useI18n();
  const { filteredComingSoonEntries } = useCatalogPageContext();
  
  return (
  <>
    {(filteredComingSoonEntries?.length || 0) > 0 && (
      <h2 className="py-2 px-5 text-center text-white bg-cornflower-blue rounded-md sm:text-2xl xs:text-xl text-md">
          {i18n.t('catalog.comingSoonBanner.text', {}, { html: true})}
      </h2>
    )}
  </>
  );
};
